import { type HttpRequestFn, useHttp, type UseHttpOptions } from '@tundr/http';
import type { GetCreditTypesResponse } from './credit-types.api.types.ts';

const getFringeCreditTypes: HttpRequestFn<GetCreditTypesResponse, void> =
  (http) => (params) => {
    return http.get('fringe-credit-types', {
      params,
    });
  };

export const useGetFringeCreditTypes = (
  options: UseHttpOptions<GetCreditTypesResponse, void> = {},
) =>
  useHttp(getFringeCreditTypes, {
    ...options,
  });
